import { convertOptionsToMap } from '../../utilities';

export const campaignStatuses: OptionType[] = [
  { value: 'active', label: 'Active' },
  { value: 'inactive', label: 'Inactive' },
  { value: 'completed', label: 'Completed' },
];

export const campaignStatusesMap = convertOptionsToMap(campaignStatuses);
